import React, {useContext, useState, useEffect} from 'react';
import styled from 'styled-components';
import {OverlayContext} from '../contexts/OverlayContext';

import {OzButton, OzCard, OzCheckbox, OzTooltip, OzRow, OzCol} from '@ozwol/webui';

import ModalWebhook3 from './ModalWebhook3';
import WebhookWizard from './WebhookWizard';

import CardHeaderTitle from '../components/CardHeaderTitle';
// import ErrorMessage from '../components/ErrorMessage';

// import {formatError} from '../helpers';
import WebhooksService from '../services/WebhooksService';

const Container = styled.div`
  width: 450px;
`;

const ModalWebhook2 = ({item, projects, onSuccess}) => {
  const {replaceOverlay, removeOverlay} = useContext(OverlayContext);
	const [currentItem, setCurrentItem] = useState(item);
	const [eventsList, setEventsList] = useState([]);
	// const [fetchError, setFetchError] = useState(false);


  useEffect(() => {
    WebhooksService.listEvents().then((response) => {
      setEventsList(response);
    }).catch((error) => {
      // setFetchError(formatError(error));
    });
  }, [setEventsList]); 

  return (
    <Container>

      <OzCard
        headerLeft={
          <CardHeaderTitle title={"Events"} />
        }
        headerSeparator={true}
        footerLeft={<OzButton variant={"chetwodeblue-o"} onClick={() => removeOverlay("webhook")}>Cancel</OzButton>}
        footerRight={
          <OzButton 
            variant={"chetwodeblue-o"} 
						disabled={!currentItem || !currentItem.events || currentItem.events.length === 0}
            onClick={() => replaceOverlay({
							reference: "webhook",
              content: <ModalWebhook3
								item={currentItem}
								projects={projects}
								onSuccess={onSuccess}
							/>,
              isCloseable: false
            }, "webhook")}
          >Next</OzButton>}
      >
        
        {/* xxx
				
				<br/><br/> */}
				
				<OzRow>
					<OzCol widthmd="12">
						{eventsList.map(event =>
							<div key={event.value}>
								<OzCheckbox 
									label={<>
											{event.value} <OzTooltip>{event.description}</OzTooltip>
										</>
									}
									selected={currentItem && currentItem.events && currentItem.events.includes(event.value)}
									onChange={(val) => {
										let tempItem = {...currentItem};   
										
										if(!tempItem.events){
											tempItem.events = [];
										}
										
										if(!tempItem.events.includes(event.value)){
											tempItem.events.push(event.value);
										}else{
											tempItem.events = tempItem.events.filter(e => e !== event.value);
										}
										setCurrentItem(tempItem);
									}}
								/>
							</div>
						)}
					</OzCol>
				</OzRow>

        <WebhookWizard step={2} />
				
      </OzCard>

    </Container>
  );

}

export default ModalWebhook2;
